import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { Eye, EyeOff, Loader2, CheckCircle2 } from "lucide-react";
import { api } from "../lib/api";
import { useT } from "../lib/i18n";
import { AuthShell } from "./Login";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

const ResetPassword = () => {
  const { t } = useT();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token") || "";
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 6) return setError(t("auth.err.password"));
    if (!token) return setError("Ongeldige of ontbrekende reset-link.");
    setBusy(true);
    try {
      await api("/auth/reset-password", { method: "POST", body: JSON.stringify({ token, new_password: password }) });
      setDone(true);
      setTimeout(() => navigate("/login"), 2000);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title={t("auth.reset.title")}>
      {done ? (
        <div className="text-center" data-testid="reset-success">
          <CheckCircle2 className="mx-auto text-success" size={40} />
          <p className="mt-4 text-sm text-slate-600">Je wachtwoord is aangepast. Je wordt doorgestuurd…</p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label className="text-sm font-semibold text-navy">{t("auth.reset.new")}</Label>
            <div className="relative mt-2">
              <Input
                className="rounded-xl pr-10"
                data-testid="reset-password"
                type={show ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="new-password"
              />
              <button type="button" onClick={() => setShow((s) => !s)} className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400">
                {show ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
          </div>
          {error && <p className="rounded-xl bg-danger/10 px-4 py-3 text-sm text-danger" data-testid="reset-error">{error}</p>}
          <Button type="submit" disabled={busy} data-testid="reset-submit" className="w-full rounded-xl bg-brandblue hover:bg-brandblue/90">
            {busy ? <Loader2 className="animate-spin" size={18} /> : t("auth.reset.submit")}
          </Button>
          <p className="text-center text-sm">
            <Link to="/login" className="font-semibold text-brandblue">
              {t("nav.login")}
            </Link>
          </p>
        </form>
      )}
    </AuthShell>
  );
};

export default ResetPassword;
